/* import __COLOCATED_TEMPLATE__ from './priority-removed-by-workflow.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type PriorityRemovedByWorkflow from 'embercom/objects/inbox/renderable/priority-removed-by-workflow';
import { truncateEventText, isEventTextTruncated } from 'embercom/lib/inbox2/event-text-truncation';

interface PriorityRemovedByWorkflowPart extends RenderablePart {
  renderableData: PriorityRemovedByWorkflow;
}

interface Args {
  part: PriorityRemovedByWorkflowPart;
}

interface Signature {
  Args: Args;
}

export default class PriorityRemovedByWorkflowComponent extends Component<Signature> {
  @service declare session: Session;

  truncateTitle(title: string | undefined): string {
    return truncateEventText(title);
  }

  isTitleTruncated(title: string | undefined): boolean {
    return isEventTextTruncated(title);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::PriorityRemovedByWorkflow': typeof PriorityRemovedByWorkflowComponent;
    'inbox2/conversation-stream/event-parts/priority-removed-by-workflow': typeof PriorityRemovedByWorkflowComponent;
  }
}
